const getInitFilters = ['connection', 'location', 'state', 'status'].map(
	(name, index) => ({
		exclude: false,
		id: index + 1,
		name,
		search: false,
		tag: '',
		value: name === 'status' ? '' : []
	})
)

export const INIT_FILTERS = getInitFilters
